import { Box, CircularProgress, Grid, IconButton, TextField, Typography } from '@mui/material'
import AutoRoundedAppLogo from '../Components/AutoRoundedAppLogo';
import { NorthEast, ReplayCircleFilledOutlined, ReplyOutlined } from '@mui/icons-material';
import { useAppContext } from '../context/useAppContext';
import Location from '../Assets/Images/LocationLogo.png'
import DarkLocation from '../Assets/Images/DarkLocationLogo.png'
import Email from '../Assets/Images/emailLogo.png'
import DarkEmail from '../Assets/Images/DarkEmailLogo.png'
import Phone from '../Assets/Images/PhoneLogo.png'
import DarkPhone from '../Assets/Images/DarekPhoneLogo.png'
import { useEffect, useState } from 'react';
import emailjs from "@emailjs/browser";
import toast from 'react-hot-toast';





function ContactPage() {
    const { darkTheme } = useAppContext();
    const [captcha, setCaptcha] = useState(generateCaptcha());
    const [userAnswer, setUserAnswer] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [])


    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
    });

    function generateCaptcha() {
        const num1 = Math.floor(Math.random() * 10);
        const num2 = Math.floor(Math.random() * 10);
        const operators = ["+", "-", "*"];
        const operator = operators[Math.floor(Math.random() * operators.length)];
        return { num1, num2, operator };
    }

    const calculateAnswer = () => {
        const { num1, num2, operator } = captcha;
        switch (operator) {
            case "+": return num1 + num2;
            case "-": return num1 - num2;
            case "*": return num1 * num2;
            default: return 0;
        }
    };

    const refreshCaptcha = () => {
        setCaptcha(generateCaptcha());
        setUserAnswer("");
        setIsValid(false);
    };

    const handleCaptchaChange = (value) => {
        setUserAnswer(value);
        const correctAnswer = calculateAnswer();
        setIsValid(Number(value) === correctAnswer);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.placeholder.toLowerCase().replace(" ", "")]: e.target.value });
    };


    const validateForm = () => {
        const { name, phone, email, subject, message } = formData;

        // Basic checks
        if (!name.trim()) return "Name is required";
        if (!phone.trim()) return "Phone is required";
        if (!email.trim()) return "Email is required";
        if (!subject.trim()) return "Subject is required";
        if (!message.trim()) return "Message is required";

        // Email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) return "Invalid email format";

        // Phone format (simple 10 digit check)
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(phone)) return "Phone must be 10 digits";

        return null;
    };


    const handleSubmit = async () => {
        const validationError = validateForm();
        setLoading(true)
        if (validationError) {
            // setError(validationError);
            toast.error(validationError);
            setLoading(false);
            return;
        }

        if (!isValid) {
            setError("Captcha is incorrect");
            setLoading(false);
            return;
        }

        setError("");

        const templateParams = {
            name: formData.name,
            phone: formData.phone,
            email: formData.email,
            subject: formData.subject,
            message: formData.message,
        };

        try {
            await emailjs.send(
                process.env.REACT_APP_SERVICEID,
                process.env.REACT_APP_TEMPLATEID,
                templateParams,
                process.env.REACT_APP_EMAIL
            );

            toast.success("Message sent successfully");

            // Reset form
            setFormData({
                name: "",
                phone: "",
                email: "",
                subject: "",
                message: "",
            });
            setUserAnswer("");
            refreshCaptcha();

        } catch (error) {
            toast.error("Failed to send message");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box mt={{ xs: 8, md: 4, lg: 5 }}>
            <Typography
                component="h1"
                variant="h1"
                sx={{
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    padding: 0,
                    margin: -1,
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0
                }}
            >
                LET'S TALK
            </Typography>
            <Grid container>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography className='fs-52 bold-text' fontWeight={900}>
                        <span className='text-color-main'>LET'S</span>{" "}
                        <span className='text-light-main'>TALK</span>
                    </Typography>
                    <Typography className='text-color-main fs-16'>Have a project in mind or need expert guidance? <br /> Get in touch with our team.<br /> We’re here to help you build and scale your next digital product.</Typography>

                    <Box className='d-flex flex-column mt-5' gap={'30px'}>
                        <TextField variant='standard' placeholder='name' value={formData.name} onChange={handleChange} />
                        <TextField variant='standard' placeholder='phone' value={formData.phone} onChange={handleChange} />
                        <TextField variant='standard' placeholder='email' value={formData.email} onChange={handleChange} />
                        <TextField variant='standard' placeholder='subject' value={formData.subject} onChange={handleChange} />
                        <TextField multiline minRows={3} variant='standard' placeholder='message' value={formData.message} onChange={handleChange} />
                    </Box>

                    {/* CAPTCHA */}
                    <Box className='d-flex align-items-center mt-5' gap={'20px'}>
                        <div className='text-color-main' style={{ fontSize: 20 }}>
                            {captcha.num1} {captcha.operator} {captcha.num2} = ?
                        </div>

                        <TextField
                            variant='standard'
                            type="number"
                            placeholder="answer"
                            value={userAnswer}
                            onChange={(e) => handleCaptchaChange(e.target.value)}
                        />

                        <IconButton onClick={refreshCaptcha}>
                            <ReplayCircleFilledOutlined sx={{ fontSize: '32px', color: "var(--primary-color)" }} />
                        </IconButton>
                    </Box>

                    {error && (
                        <Typography style={{ color: "red", marginTop: "12px" }}>
                            {error}
                        </Typography>
                    )}

                    {/* SUBMIT */}
                    <Box component={'button'} border={'none'} sx={{ border: 'none', cursor: isValid ? 'pointer !important' : 'not-allowed !important', backgroundColor: 'transparent', '&:hover': { backgroundColor: 'transparent' } }} disabled={!isValid} onClick={() => { handleSubmit() }} className='align-items-center mt-5' display={{ xs: 'flex' }} order={3}>
                        <Typography className='chat-bg fs-18 btn-light-main text-color-main'>{loading ? "Sending..." : "Submit"}</Typography>
                        <Box className='btn-light-main message-bg' maxHeight={'55px'}>
                            {loading ? <CircularProgress sx={{ color: 'var(--primary-dark-color)' }} /> : (
                                <NorthEast sx={{ color: 'var(--primary-dark-color)' }} />
                            )}
                        </Box> </Box>

                </Grid>
                <Grid size={6} justifyContent={'center'} className='d-flex'>
                    <AutoRoundedAppLogo />
                </Grid>
            </Grid>
            <Grid container mt={5} alignItems={'start'}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography sx={{ fontSize: { xs: "68px", md: "150px" } }} className='text-color-main' gutterBottom fontWeight={500}>
                        GET IN
                        TOUCH </Typography>

                </Grid>
                <Grid size={{ xs: 12, md: 6 }} justifyContent={'center'} className='d-flex flex-column' gap={"10px"}>
                    <Box className='d-flex align-items-start mb-2' gap={'10px'}>
                        <Box component={'img'} src={darkTheme ? DarkLocation : Location} height={'50px'}></Box>
                        <Typography className='text-color-main fs-32'>8/330 Collins St, Melbourne, <br />
                            VIC, Australia, 3000</Typography>
                    </Box>
                    <Box className='d-flex align-items-start mb-3' gap={'10px'}>
                        <Box component={'img'} src={darkTheme ? DarkEmail : Email} height={'50px'}></Box>
                        <Typography className='text-color-main fs-32'>info@appgallery.com.au</Typography>
                    </Box>
                    <Box className='d-flex align-items-start mb-2' gap={'10px'}>
                        <Box component={'img'} src={darkTheme ? DarkPhone : Phone} height={'50px'}></Box>
                        <Typography className='text-color-main fs-32'>(T) 1300 133 834 <br />
                            (M) 0430 276 367</Typography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mt={5}>
                <iframe
                    className='border-10'
                    src="https://www.google.com/maps?q=-37.8162199,144.9632995&output=embed"
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    allowfullscreen=""
                    loading="lazy"

                >
                </iframe>
            </Grid>
        </Box>
    )
}

export default ContactPage
